import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {QuestionnaireComponent} from './questionnaire/questionnaire.component';
import {Module1Component} from "./modules/module1/module1.component";
import {Module8Component} from "./modules/module8/module8.component";
import {Module2Component} from "./modules/module2/module2.component";
import {Module3Component} from "./modules/module3/module3.component";
import {Module4Component} from "./modules/module4/module4.component";
import {Module5Component} from "./modules/module5/module5.component";
import {Module6Component} from "./modules/module6/module6.component";
import {Module7Component} from "./modules/module7/module7.component";
import {HomeComponent} from "./home/home.component";

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'modul-1', component: Module1Component},
    {path: 'modul-2', component: Module2Component},
    {path: 'modul-3', component: Module3Component},
    {path: 'modul-4', component: Module4Component},
    {path: 'modul-5', component: Module5Component},
    {path: 'modul-6', component: Module6Component},
    {path: 'modul-7', component: Module7Component},
    {path: 'modul-8', component: Module8Component},

    {path: 'kerdoiv', component: QuestionnaireComponent},

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
